import { FC, PropsWithChildren } from 'react';

import { useElementShown } from '@hh.ru/analytics-js';
import calculatorElementShown from '@hh.ru/analytics-js-events/build/career_platform/profession/calculator_element_shown';

import { useCalculatorContext } from 'src/pages/Profession/components/SectionCalculator/Context';

const SectionContainer: FC<PropsWithChildren> = ({ children }) => {
    const { professionId, gradeId } = useCalculatorContext();

    const ref = useElementShown(calculatorElementShown, {
        professionId,
        levelId: gradeId,
    });

    return <section ref={ref}>{children}</section>;
};

export default SectionContainer;
